module.exports = __webpack_public_path__ + "img/locked.b10d5293.svg";